<div [formGroup]="form">
    <h1 mat-dialog-title>Bewertung melden</h1>
    <mat-dialog-content>
        <mat-form-field class="input" appearance="outline">
            <textarea matInput rows="10" cols="30" formControlName="reason"
                placeholder="Bitte geben Sie den Grund für die Meldung dieser Bewertung an." required></textarea>
            <mat-error *ngIf="form.get('reason').invalid">
                Meldegrund wird benötigt.
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <div mat-dialog-actions>
        <button matButton="elevated" (click)="onSubmit(false)" color="warn" cdkFocusInitial>
            {{ dialogData.buttonNo }}
        </button>
        <button matButton="elevated" (click)="onSubmit(true)" class="green-confirm" [disabled]="form.invalid">
            {{ dialogData.buttonYes }}
        </button>
    </div>
</div>